module.exports = __webpack_public_path__ + "static/img/cjfw-enterpriseCulture1.768143fb.png";